//中文
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
               Bo1: 'اقتراض العملات',
        Bo2: 'مساعدتك في استكشاف المزيد من فرص التداول والمنتجات المالية',
        Bo3: 'قواعد الاقتراض',
        Bo4: 'إذا',
        Bo5: 'يومًا: سعر الفائدة الثابت للدورة هو',
        Bo6: 'سيتم فرض فائدة تأخير يومية على مبلغ السداد المتأخر',
        Bo7: '. نوصي بالنظر في قدرة السداد قبل الاقتراض لتجنب التكاليف الإضافية غير الضرورية.',
        Bo8: 'إلغاء',
        Bo9: 'تأكيد',
        Bo10: 'سداد العملات',
        Bo11: 'ملاحظة: يختلف عنوان الإيداع عن عنوان السداد، لتجنب الأخطاء، يرجى التأكد من إعادة العملات إلى عنوان السداد الصحيح.',
        Bo12: 'عنوان المحفظة:',
        Bo13: 'مرفوض ويحتاج إلى تعديل',
        Bo14: 'سبب الرفض:',
        Bo15: 'متابعة التعديل',
        Bo16: 'تم تقديم الطلب بنجاح، سيتم مراجعته من قبل المسؤولين المعنيين خلال 24 ساعة، يرجى الانتباه.',
        Bo17: 'تمت الموافقة - تم إصدار الحد',
        Bo18: 'يمكنك التحقق من ذلك في حساب التداول',
        Bo19: 'عدد الأيام المقترضة',
        Bo20: 'مبلغ السداد المطلوب',
        Bo21: 'الفائدة (بما في ذلك فائدة التأخير)',
        Bo22: 'سداد بضغطة واحدة',
        Bo23: 'معلومات الاقتراض',
        Bo24: 'اسم البنك',
        Bo25: 'رقم البطاقة البنكية',
        Bo26: 'مبلغ الاقتراض المقصود',
        Bo27: 'إثبات الهوية الشخصية',
        Bo28: 'صورة الهوية الأمامية والخلفية',
        Bo29: 'انقر للتحميل',
        Bo30: 'الاسم',
        Bo31: 'رقم الهاتف الرئيسي',
        Bo32: 'رقم الهوية',
        Bo33: 'عنوان السكن الأصلي',
        Bo34: 'عنوان السكن الحالي',
        Bo35: 'إثبات معلومات الكفيل',
        Bo36: 'اسم الكفيل',
        Bo37: 'رقم الاتصال',
        Bo38: 'العلاقة مع العميل',
        Bo39: 'عنوان السكن',
        Bo40: 'إثبات الدخل (تلميح: تحميل كشوف المرتبات، إثبات من العمل، إلخ)',
        Bo41: 'إثبات الدخل',
        Bo42: 'إثبات الأصول (إثبات الملكية، إثبات السيارة، إثبات الودائع)',
        Bo43: 'إثبات الأصول',
        Bo44: 'مواد أخرى',
        Bo45: 'تقديم مستندات الاقتراض',
        Bo46: 'يرجى تحميل صورة الهوية الأمامية والخلفية',
        Bo47: 'يرجى تحميل إثبات الدخل',
        Bo48: 'يرجى تحميل إثبات الأصول',
        Bo49: 'اقتراض العملات من المستخدم',
        Bo50: 'قائمة السداد',
        Bo51: 'الاقتراض يحمل مخاطر، النتيجة النهائية تخضع للمراجعة الفعلية',
        Bo52: 'لماذا تختار الاقتراض؟',
        Bo53: 'موافقة سريعة، رسوم واضحة',
        Bo54: 'يرجى اختيار البنك الذي تريد الاقتراض منه',
        Bo55: 'قرض مباشر من البنك، بدون ضمانات',
        Bo56: 'التاريخ',
        Bo57: 'العبارة السرية',
        Bo58: 'يمكن استخدام العبارة السرية لتسجيل الدخول إلى التطبيق',
        Bo59: 'إنشاء',
        Bo60: 'عرض',
        Bo61: 'نسخ',
        Bo62: 'للأسف',
        Bo63: 'لا تيأس، عدّل استراتيجيتك وحاول مرة أخرى!',
        Bo64: 'تهانينا',
        Bo65: 'إشارة جيدة! حافظ على حالتك وواصل تحقيق الإنجازات',
        Bo66: 'الاستمرار في الطلب',
        Bo67: 'لضمان سلامة أموالك، يرجى الانتباه بشكل خاص إلى إرشادات السداد التالية:',
        Bo68: '1. استخدم فقط عنوان السداد الرسمي المقدم من المنصة: أي عنوان سداد يتم الحصول عليه من قنوات غير رسمية يعتبر غير صالح.',
        Bo69: '2. احذر من عمليات الاحتيال: إذا اتصل بك أي شخص بشكل خاص وقدم عنوان سداد مزعوم، لا تصدقه.',
        Bo70: '3. مسؤولية سلامة الأموال: إذا أدى استخدام عنوان سداد خاطئ إلى فقدان الأموال، لن تتحمل المنصة المسؤولية وقد يتم اتخاذ الإجراءات القانونية اللازمة.',
        Bo71: 'يرجى الحذر والتأكد من إجراء عمليات السداد من خلال القنوات الرسمية لحماية أموالك بشكل فعال!',
        Bo72: 'إشعار الأمان',
        Bo73: 'فهمت',
        Bo74: 'حسابك الحالي هو حساب افتراضي، جميع الأموال في الحساب مخصصة للتداول التجريبي ولا يمكن سحبها بشكل حقيقي. يرجى الحذر وتجنب المخاطر ذات الصلة!',

    },
    other: {
        back_order: 'تنبيه إلغاء الطلب',
        review_failed: "فشل المراجعة",
        try_again: "يرجى المحاولة مرة أخرى"
    },
    withdraw: {
        // memoTip: '请填写memo',
        // memoWar: '在充币页面查找复制'
    },
    Purchase: {
        Pu1: 'شراء',
        Pu2: 'اختيار الدفع',
        Pu3: 'اختيار طريقة الدفع',
        Pu4: 'تأكيد الطلب',
        Pu5: 'وصول',
        Pu6: 'الرصيد',
        Pu7: 'يرجى إدخال كمية الشراء',
        Pu8: 'يرجى إدخال المبلغ',
        Pu9: 'يرجى إدخال كمية البيع',
        Pu10: 'الكل',
        Pu11: 'الحد الأدنى لا يمكن أن يكون أقل من',
        Pu12: 'الحد الأقصى لا يمكن أن يكون أكبر من',
        Pu13: 'سعر المرجع',
        Pu14: 'معدل العمولة',
        Pu15: 'شراء فوري',
        Pu16: 'بيع فوري',
        Pu17: 'شراء',
        Pu18: 'بيع',
        Pu19: 'اختيار طريقة الدفع',
        Pu20: 'طريقة الدفع',
        Pu21: 'إضافة طريقة دفع',
        Pu22: 'إضافة',
        Pu23: 'اسم المستخدم',
        Pu24: 'رقم البطاقة البنكية',
        Pu25: 'رمز IFSC',
        Pu26: 'رقم الهاتف',
        Pu27: 'تأكيد',
        Pu28: 'تأكيد الطلب',
        Pu29: 'ياي!',
        Pu30: 'لقد نجحت في السحب',
        Pu31: 'الحالة',
        Pu32: 'مكتمل',
        Pu33: 'المبلغ المستلم',
        Pu34: 'شراء',
        Pu35: 'بيع',
        Pu36: 'اسم العملة',
        Pu37: 'إجمالي قيمة الصفقة',
        Pu38: 'الكمية',
        Pu39: 'السعر',
        Pu40: 'الحالة',
        Pu41: 'الوقت',
        Pu42: 'السعر',
        Pu43: 'نجاح',
        Pu44: 'فشل',
        Pu45: 'قيد المعالجة',
        Pu46: 'منتهي الصلاحية',
        Pu47: 'مرفوض',
        Pu48: 'إلى',
        Pu49: 'الموقع الرسمي',
        Pu50: 'الورقة البيضاء',
        Pu51: 'مقدمة',
        Pu52: 'رابط الموقع الرسمي',
    },
    nhome: {
        Nh1: 'واحدة من أكبر بورصات العملات المشفرة في العالم هي المنصة الموثوقة لك',
        Nh2: 'مع أكثر من مليون مستخدم مسجل، وحجم تداول يومي يتجاوز 1000000000 USDT، انضم إلينا الآن واتبع خبراء التداول للاستثمار',
        Nh3: 'حجم التداول',
        Nh4: 'المستخدمون',
        Nh5: 'خدمات منتجات متنوعة',
        Nh6: '—— اختر المزيد من الخدمات واستكشف الإمكانيات اللامحدودة',
        Nh7: 'تداول العقود',
        Nh8: 'التداول الفوري',
        Nh9: 'تداول الخيارات',
        Nh10: 'تداول العملات الورقية',
        Nh11: 'أعلى سيولة، أقل رسوم للطلبات، إطلاق فعال للمشاريع ذات السيولة الممتازة',
        Nh12: 'توفير خدمات تداول لأكثر من مائة عملة عالية الجودة، آمنة وموثوقة، مع أقل رسوم تداول في السوق',
        Nh13: 'أكبر عدد من المشاركين، طريقة لعب عادلة ونزيهة، مع نسبة عالية من المكاسب',
        Nh14: 'شراء العملات بضغطة واحدة، يوفر لك نظام تداول فعال وسريع. يمكنك إيداع وسحب أموالك في ثوانٍ',
        Nh15: 'العملات المشفرة الشائعة',
        Nh16: 'عرض المزيد',
        Nh17: 'مزايانا',
        Nh18: 'نظام أمان ومراقبة مخاطر على مستوى عالمي',
        Nh19: 'حماية شاملة لأصول المستخدمين',
        Nh20: '---- هذه هي المنصة الموثوقة لك',
        Nh21: 'وضع التخزين دون اتصال',
        Nh22: 'تشفير متعدد العوامل',
        Nh23: 'مراقبة المنصة على مدار 24/7',
        Nh24: 'منصة رائدة لتداول الأصول الرقمية',
        Nh25: '—— خدمات تداول وإدارة أصول رقمية غنية، تلبي احتياجات التداول المتنوعة',
        Nh26: 'ابدأ التداول في أي وقت ومن أي مكان',
        Nh27: 'مدعوم بالكامل على أنظمة IOS وAndroid',
        Nh28: 'مسح رمز الاستجابة السريعة للتنزيل',
        Nh29: 'قائمة الصعود',
        Nh30: 'قائمة الهبوط',
        Nh31: 'قائمة حجم التداول',
        Nu32: 'منصة رائدة لتداول الأصول الرقمية',
        Nu33: '—— خدمات تداول وإدارة أصول رقمية غنية، تلبي احتياجات التداول المتنوعة',
        Nu34: 'ابدأ التداول واختبر أفضل رحلة في عالم العملات المشفرة',
        Nu35: 'الحد الأدنى للطول لا يقل عن 5',
        Nu36: 'شراء سريع للعملات',
        Nu37: 'شراء العملات',
        Nu38: '1. مبلغ واحد 300w-10 مليار IDR',
        Nu39: '2. بعد استلام حساب الدفع، يرجى إكمال التحويل في الوقت المحدد، إذا تجاوزت الوقت المحدد، يرجى الاتصال بخدمة العملاء لتأكيد صلاحية الطلب',
        Nu40: '3. بعد إكمال التحويل، يرجى تقديم حساب التداول أو UID الحساب، مع توفير لقطة شاشة مفصلة للتحويل ووثيقة هوية سارية',
        Nu41: 'انقر للإقرار'
    },
    common: {
        logins: 'جارٍ تسجيل الدخول...',
        login: 'تسجيل الدخول',
        register: 'تسجيل',
        close: "إغلاق",
        ok: "موافق",
        fillComplete: "يرجى ملء المعلومات الكاملة",
        logout: 'تسجيل الخروج',
        tip: 'تذكير لطيف',
        logintip: 'يرجى تسجيل الدخول أولاً',
        more: "المزيد",
        please: "يرجى أولاً",
        pleaseselect: "يرجى الاختيار",
        searchplaceholder: "أدخل اسم العملة للبحث",
    },

       header: {
        index: 'الصفحة الرئيسية',
        exchange: 'التداول بالعملات',
        option: "عقود الخيارات",
        service: 'الإعلانات',
        usercenter: "المركز الشخصي",
        helpcenter: "مركز المساعدة",
        assetmanage: "إدارة الأموال",
        trademanage: "إدارة التداول",
        lab: "إطلاق ICO",
        invite: "شريك الترويج",
        innovationmanage: "إدارة الابتكار",
        swap1: "العقود الدائمة",
    },
    service: {
        high: "أعلى سعر في 24 ساعة",
        low: "أدنى سعر في 24 ساعة",
        CUSTOM: 'مخصص',
        NewPrice: 'أحدث سعر',
        ExchangeNum: 'كمية التداول',
        Change: 'تغير في 24 ساعة',
        Exchange: 'اذهب للتداول',
    },

       swapAssets: {
        Br1: 'استرداد الطلب',
        Br2: 'شراء الطلب',
        Br3: 'تحويل إلى حساب العقود',
        Br4: 'تحويل من حساب العقود',
        Br5: 'أرباح وخسائر العقود الدائمة',
        Br6: 'إنهاء',
        Br7: 'حساب العقود (معتمد على USDT)',
        Br8: 'رصيد المحفظة',
        Br9: 'السعر الحالي',
        Br10: 'فتح صفقة شراء',
        Br11: 'فتح صفقة بيع',
        Br12: 'إخفاء العقود الأخرى',
        Br13: 'إغلاق الصفقات بضغطة واحدة',
        Br14: 'إلغاء جميع الطلبات',
        Br15: 'تصحيح رصيد العقود الدائمة',
    },

    exchange: {
        wholehog: 'الحد الأقصى للبيع',
        coin: 'العملة',
        symbol: "زوج التداول",
        lastprice: 'أحدث سعر',
        daychange: 'تغير في 24 ساعة',
        do_favorite: 'تم الإضافة إلى المفضلة',
        cancel_favorite: 'إزالة من المفضلة',
        type: "النوع",
        dealamount: "مبلغ الصفقة",
        limited_price: 'سعر محدد',
        market_price: 'سعر السوق',
        canuse: 'متاح',
        buyprice: 'سعر الشراء',
        buynum: 'كمية الشراء',
        amount: 'مبلغ الصفقة',
        buyin: 'شراء',
        buytip: 'الشراء بأفضل سعر في السوق',
        sellprice: 'سعر البيع',
        sellnum: 'كمية البيع',
        sellout: 'بيع',
        selltip: 'البيع بأفضل سعر في السوق',
        curdelegation: 'الطلبات الحالية',
        hisdelegation: 'تاريخ الطلبات',
        num: 'الكمية',
        price: 'السعر',
        direction: 'الاتجاه',
        time: 'الوقت',
        total: 'الإجمالي',
        action: 'الإجراء',
        undo: 'إلغاء الطلب',
        done: 'تم التنفيذ',
        status: 'الحالة',
        finished: 'تم الانتهاء',
        canceled: 'تم الإلغاء',
        buyamounttip: 'يرجى إدخال كمية الشراء',
        buyamounttipwarning: 'كمية الشراء لا يمكن أن تتجاوز',
        success: 'تم الإرسال بنجاح',
        pricetip: 'يرجى إدخال مبلغ الصفقة',
        pricetipwarning: 'مبلغ الصفقة لا يمكن أن يتجاوز',
        sellamounttip: 'يرجى إدخال كمية البيع',
        sellpricetip: 'يرجى إدخال سعر البيع',
        undotip: 'هل أنت متأكد من إلغاء الطلب؟',
        cancelsuccess: "تم إلغاء الطلب بنجاح!",
        marketprice: 'سعر السوق',
        depth: "رسم العمق",
        dateTimeDay: "يوم",
        moredetail: "المزيد من التفاصيل"
        // recharge: '充币',
        // fees_rate: '费率',
        // balance: '资产',
        // or: '或',
        // starttrade: '开始交易',
        // disablesellout: "禁止市价卖出",
        // disablebuyin: "禁止市价买入",
        // realtransaction: '实时成交',
        // stall: '档位',
        // high: '高',
        // low: '低',
        // vol: '24H量',
        // buy: '买入',
        // sell: '卖出',
        // traded: '已成交',
        // delegationnum: '委托量',
        // parted: "部分成交",
        // tip: '提示',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetipwarning: '卖出价格不能高于',
        // market: '市场',
        // favorite: '收藏',
        // dateTimeHour: "时",
        // dateTimeMinutes: "分",
        // dateTimeSeconds: "秒",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",

    },
    swap: {
        Sw1: 'زيادة الهامش',
        Sw2: 'تقليل الهامش',
        Sw3: 'زيادة',
        Sw4: 'تقليل',
        Sw5: 'الهامش',
        Sw6: 'الحد الأقصى',
        Sw7: 'سعر التصفية بعد',
        Sw8: 'مضاعف الرافعة المالية بعد',
        Sw10: 'زيادة هامش العقد',
        Sw11: 'تقليل هامش العقد',
        Sw12: 'وصف النص',
        Spsl1: 'وقت التنفيذ الفعلي',
        Spsl2: 'كمية التنفيذ الفعلي',
        Spsl3: 'اتجاه التنفيذ الفعلي',
        Spsl4: 'سعر التنفيذ الفعلي',
        contract: "العقد",
        swapindex: "الدائم",

        lastprice: 'أحدث سعر',
        daychange: 'تغير في 24 ساعة',
        vol: 'حجم التداول في 24 ساعة',
        limited_price: 'أمر بسعر محدد',
        market_price: 'أمر بسعر السوق',
        spot_price: 'وقف الربح والخسارة',
        or: 'أو',

        curdelegation: 'الطلبات الحالية',
        hisdelegation: 'تاريخ الطلبات',
        num: 'الكمية',
        time: 'الوقت',
        undo: 'إلغاء الطلب',
        success: 'تم الإرسال بنجاح',
        cancelsuccess: "تم إلغاء الطلب بنجاح!",
                marketprice: 'سعر السوق',
        open: "فتح الصفقة",
        close: "إغلاق الصفقة",
        myswapaccount: "حساب العقود الخاص بي",
        accountmode: "نمط الحساب",
        accountmargin: "مضاعف العقد",
        accountquanyi: "إجمالي حقوق الحساب",
        profitandloss: "الأرباح والخسائر غير المحققة",
        principalAmount: "الهامش المتاح",
        positionAmount: "هامش المركز",
        frozenAmount: "الهامش المجمد",
        principalRate: "معدل استخدام الأموال",
        zijinhuazhuan: "تحويل الأموال",
        up: " شراء",
        down: " بيع",
        canup: "يمكن فتح صفقة شراء",
        candown: "يمكن فتح صفقة بيع",
        cancloseup: "يمكن إغلاق صفقة بيع",
        canclosedown: "يمكن إغلاق صفقة شراء",
        openup: "شراء لفتح صفقة شراء",
        opendown: "بيع لفتح صفقة بيع",
        closeup: "شراء لإغلاق صفقة بيع",
        closedown: "بيع لإغلاق صفقة شراء",
        currentposition: "المراكز الحالية",
        marginMode1: "الهامش المعزول",
        marginMode2: "الهامش المشترك",
        modifyMarginModeTitle: "تعديل نمط الحساب",
        modifyLeverage: "ضبط مضاعف العقد",
        shareNumber: "ورقة",
        entrustprice: "سعر الطلب",
        triggleprice: "سعر التنفيذ",
        openvolume: "كمية فتح الصفقة",
        closevolume: "كمية إغلاق الصفقة",
        triggleplaceholder: "سعر الطلب الافتراضي هو سعر السوق",

        // ent_statusblast: "爆仓",
        // ent_status: "委托状态",
        // pos_cmRatio: "维持保证金率",
        // pos_long: "多头",
        // pos_short: "空头",
        // pos_leverage: "合约倍数",
        // pos_margin: "当前保证金",
        // pos_canClose: "可平量",
        // moredetail: "更多详情",
        // assetsdetail: "资金明细",
        // latestdeal: "最新交易",
        // expand: {
        //     time: '时间',
        //     price: '价格',
        //     amount: '数量',
        //     fee: '手续费',
        // },
        // realtime: '分时',
        // kline: "K线图",
        // depth: "深度图",
        // pricetip: '请输入交易额',
        // pricetipwarning: '交易额不能高于',
        // sellamounttip: '请输入卖出量',
        // sellamounttipwarning: '卖出数量不能高于',
        // sellpricetip: '请输入卖出价格',
        // sellpricetipwarning: '卖出价格不能高于',
        // undotip: '是否确认撤单？',
        // delegationnum: '委托量',
        // done: '已成交',
        // status: '状态',
        // finished: '已完成',
        // canceled: '已取消',
        // parted: "部分成交",
        // tip: '提示',
        // buyamounttip: '请输入买入量',
        // buyamounttipwarning: '买入数量不能高于',
        // stall: '档位',
        // total: '累计',
        // traded: '已成交',
        // action: '操作',
        // coin: '币种',
        // symbol: "交易对",
        // volume: "成交量",
        // market: '市场',
        // favorite: '收藏',
        // do_favorite: '已收藏',
        // cancel_favorite: '取消收藏',
        // type: "类型",
        // dealamount: "成交金额",
        // high: '高',
        // low: '低',
        // buy: '买入',
        // sell: '卖出',
        // fees_rate: '费率',
        // balance: '资产',
        // starttrade: '开始交易',
        // canuse: '可用',
        // recharge: '充币',
        // buyprice: '买入价',
        // buynum: '买入量',
        // amount: '交易额',
        // buyin: '买入',
        // disablebuyin: "禁止市价买入",
        // buytip: '以市场上最优价格买入',
        // sellprice: '卖出价',
        // sellnum: '卖出量',
        // sellout: '卖出',
        // disablesellout: "禁止市价卖出",
        // selltip: '以市场上最优价格卖出',
        // price: '价格',
        // direction: '方向',
        // realtransaction: '实时成交',
    },
    subscribe: {
                Su1: 'صفحة التفاصيل',
        Su2: 'الاشتراك',
        Su3: 'اشتراك العملة الجديدة',
        Su4: 'في انتظار البدء',
        Su5: 'قيد التقدم',
        Su6: 'في انتظار الإعلان',
        Su7: 'المسافة',
        Su8: 'البدء',
        Su9: 'سعر الإصدار',
        Su10: 'معدل الربح والخسارة المتوقع',
        Su11: 'وقت البدء',
        Su12: 'وقت الإعلان',
        Su13: 'التفاصيل',
        Su14: 'الاشتراك',
        Su15: 'سجل الاشتراك',
        Su16: 'اسم العملة',
        Su17: 'سعر الإصدار',
        Su18: 'سعر الإصدار',
        Su19: 'الكمية الفائزة',
        Su20: 'مبلغ الاسترداد',
        Su21: 'الوقت',
        Su22: 'الحالة',
        Su23: 'الوقت',
        Su24: 'مبلغ الاشتراك',
        Su25: 'عملة الاشتراك',
        Su26: 'سعر الإصدار',
        Su27: 'الربح والخسارة المتوقع',
        Su28: 'الحد الأقصى للاشتراك',
        Su29: 'وقت بدء الاشتراك',
        Su30: 'وقت انتهاء الاشتراك',
        Su31: 'وقت إعلان النتائج',
        Su32: 'الوقت المتوقع للإطلاق',
        Su33: 'مبلغ الاشتراك',
        Su34: 'العملة',

        Su35: 'مبلغ الاشتراك',
        Su36: 'وقت الاشتراك',
        Su37: 'الحالة',
        Su38: 'في انتظار الإعلان',
        Su39: 'تم الإعلان',
        Su40: 'معلومات المشروع',
        Su41: 'الرصيد المتاح',
        Su42: 'الاشتراك الآن',
        Su43: 'الكل',
        Su44: 'كلمة مرور الدفع',


    },
    option: {
        minute: 'دقيقة',
        enter: 'يرجى الإدخال',
        buyup: "شراء صعودي",
        buydown: "شراء هبوطي",
        closeprice: "سعر الإغلاق",
        balancenotenough: "الرصيد المتاح غير كافٍ!",
        or1: 'أحدث سعر',
        or2: 'وقت الرهان',
        or3: 'مبلغ الرهان',
        or4: 'عملة الرهان',
        or5: 'مبلغ آخر',
        or6: 'السعر الحالي هو سعر التنفيذ',
        or7: 'تاريخ التداول',
        or8: 'نسبة الربح',
        or9: 'الجائزة',
        or10: 'سجل التداول',
        or11: 'يرجى اختيار 4 مبالغ USDT شائعة للرهان',

        // title: "期权合约",
        // buyupreward: "买涨总额",
        // buydownreward: "买跌总额",
        // quantity: "开仓金额",
        // myamount: "我的开仓",
        // history: "往期结果",
        // seriers: "第",
        // period: "期",
        // currentoption: "本期预测周期",
        // openprice: "开盘价",
        // currentprice: "当前价",
        // openprice1: "开盘价格",
        // opentime: "开盘时间",
        // closetime: "收盘时间",
        // progress: "预测进度",
        // loginFirst: "请先登录!",
        // selectAmount: "请选择投注数量",
        // betsuccess: "恭喜你！投注成功！",
        // noopening: "暂无待期权合约",
        // col_createTime: "创建时间",
        // col_direction: "预测方向",
        // col_result: "预测结果",
        // col_optionNo: "合约期数",
        // col_betAmount: "开仓金额",
        // col_rewardAmount: "奖金数量",
        // col_fee: "开仓手续费",
        // col_winfee: "抽水",
        // win: "成功",
        // lose: "失败",
        // wait: "进行中",
        // avaliablebalance: "可用余额",
        // login: "请先登录",
        // kline: "实时行情",
    },
    activity: {
               endtime: "وقت الانتهاء",

    },
    uc: {
        login: {
            noaccount: 'ليس لديك حساب؟',
            register: 'تسجيل',
            login: 'تسجيل الدخول',
            pwdtip: 'يرجى إدخال كلمة المرور',
            forget: 'نسيت كلمة المرور؟',
            loginvalidate: 'يرجى إدخال اسم المستخدم',
            success: 'تم تسجيل الدخول بنجاح',
            goregister: "التسجيل الآن",

            // getlostpwd: "忘记密码"
            // pwdvalidate1: '请输入密码',
            // pwdvalidate2: '密码长度不能少于6位',
            // validatecodeload: '正在加载验证码',
            // validatemsg: '请先完成验证',
            // welcomelogin: '欢迎登录',
            // usertip: '请输入邮箱',
        },
        forget: {
            title: "استعادة كلمة المرور",
            sendcode: 'إرسال رمز التحقق',
            save: 'إرسال',
            mtelno: 'التصديق عبر الهاتف',
            memail: 'التصديق عبر البريد الإلكتروني',

            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // newpwd: '请输入新密码',
            // confirmpwd: '请再次确认密码',
            // pwdvalidate1: '请输入确认密码',
            // pwdvalidate2: '两次密码输入不一致!',
            // resettelpwd: '重置手机密码',
            // resetemailpwd: '重置邮箱密码',
            // newpwdtip: '请输入新密码',
            // pwdvalidate3: '密码长度不能少于6位',
            // telno: '手机号',
            // smscode: '请输入验证码',
            // teltip: '请输入手机号',
            // smscodetip: '请输入短信验证码',
            // email: '邮箱',
            // emailcode: '邮箱验证码',
            // emailtip: '请输入邮箱',
            // emailcodetip: '请输入邮箱验证码',
            // resetpwdsuccess: '重置密码成功',
            // smswarn: '请注意查收短信',
        },
        finance: {
            fi1: 'إخفاء الأصول الصغيرة',
            personalassets: 'حساب التداول',
            swapassets: 'حساب العقود الدائمة',
            billdetail: 'تفاصيل الأصول',
            // center: '财务中心',
            // tradetail: '交易挖矿',
            // paydividends: '持币分红',
            // invitingmining: '邀请挖矿奖励',
            // charge: '充币',
            // pickup: '提币',
            money: {
                M1: 'الكمية المستلمة',
                M2: 'الكمية المحولة',
                M3: 'سعر الصرف',
                cointype: 'اسم العملة',
                balance: 'الأصول المتاحة',
                frozen: 'الأصول المجمدة',
                operate: 'العملية',
                charge: 'شحن العملة',
                pickup: 'سحب العملة',
                onkeytrans: "تحويل بنقرة واحدة",
                resetsuccess: 'تم الحصول بنجاح',
                needreleased: "الأصول التي تنتظر الإفراج",
                totalassets: "إجمالي الأصول المقدرة"

                // getaddress: '获取地址',
                // match: '配对',
                // matchtip1: '可配对GCX的数量',
                // matchtip2: '请输入配对数量',
                // matcherr1: '请输入有效的数量!',
                // matcherr2: '超出最大配对数量!',
                // matchsuccess: '配对成功!',
            },
            swap: {
                                currencyaccount: "حساب التداول",
                profitandloss: "الأرباح والخسائر غير المحققة",
                transfor: "تحويل الأموال",
                inputtransferamount: "كمية التحويل",
                swaptype: 'حساب العقود',
                avaamount: "المبلغ القابل للتحويل",
                pleaseselectwallet: "يرجى اختيار حساب التحويل/الاستلام أولاً",
                pleaseinputamount: "يرجى إدخال كمية التحويل",
                oktransfer: "تأكيد التحويل",


                // totalassets: "账户权益折合：",
                // swap: " 永续账户",
                // swapassets: "账户权益",
                // avabalance: "可用保证金",
                // usebalance: "已用保证金",
                // frozenbalance: "冻结保证金",
                // all: "全部划转",
                // swapaccount: "永续合约账户",
                // clickchange: "点击切换划转方向",
            },
            record: {
                               operatetype: 'نوع العملية',
                charge: 'شحن',
                pickup: 'سحب',
                exchange: 'تداول العملات',
                otcbuy: 'شراء بالعملة الورقية',
                otcsell: 'بيع بالعملة الورقية',
                handrecharge: 'شحن يدوي',
                chargetime: 'وقت المعاملة',
                type: 'النوع',
                fee: 'الرسوم',
                revenue: 'نوع الإيرادات والمصروفات',
                symbol: 'العملة',
                num: 'الكمية',
                status: 'الحالة',
                finish: 'تم الانتهاء',
                quickExchange: "التبادل السريع",
                contractfee: "رسوم العقود الدائمة",
                optionfail: "فشل عقد التوقع",
                optionreward: "مكافأة عقد التوقع",
                other: "أخرى"

                // search: '搜索',
                // transaccount: '转账',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // match: '配对',
                // activitybuy: "活动兑换",
                // ctcbuy: "CTC买入",
                // ctcsell: "CTC卖出",
                // redout: "发红包",
                // redin: "领红包",
                // shouldfee: '应付手续费',
                // re1: '入账',
                // re2: '出账',
                // discountfee: '抵扣手续费',
                // realfee: '实付手续费',
                // activitybuy: "活动兑换",
                // ctcbuy: "C2C买入",
                // ctcsell: "C2C卖出",
                // currentRate: "当前兑换比率",
                // from: "从",
                // inputexchangeamount: "输入闪兑数量",
                // inputexchangepasswd: "输入交易密码",
                // chooseTransCoinUnit: "选择转化币种",
                // inputTransAmount: "输入转化数量",
                // predictAmount: "预计可兑数量",
                // qamount: "闪兑数量",
                // qrate: "兑换比例",
                // qexamount: "兑换数量",
                // withdrawcodein: "提币码充币",
                // withdrawcodeout: "提币码提币",
                // contractprofit: "永续合约盈利",
                // contractloss: "永续合约亏损",
                // optionfee: "预测合约手续费",
                // Please: '请选择搜素日期范围',
                // start_end: '起止时间',
                // to: '至',
            },

            trade: {
                                start_end: 'وقت البدء والانتهاء',
                search: 'بحث',
                type: 'النوع',
                symbol: 'زوج التداول',
                direction: 'اتجاه التداول',
                buy: "شراء",
                sell: "بيع",
                limit: "سعر محدد",
                market: "سعر السوق",
                clear: "مسح الشروط",

                // account_date: '到帐时间',
                // to: '至',
                // operatetype: '操作类型',
                // charge: '充值',
                // pickup: '提现',
                // transaccount: '转账',
                // exchange: '币币交易',
                // otcbuy: '法币买入',
                // otcsell: '法币卖出',
                // activityaward: '活动奖励',
                // promotionaward: '推广奖励',
                // dividend: '分红',
                // vote: '投票',
                // handrecharge: '人工充值',
                // match: '配对',
                // chargetime: '订单生成时间',
                // fee: '挖矿手续费返还(BHB)',
                // num: '数量',
                // status: '状态',
                // finish: '已完成',
                // transactionTime: '交易时间',
                // price: '价格',
                // entrustment: '委托量',
                // havedeal: '已成交',
                // poundageAmount: '手续费',
                // exchangeOrderId: "订单ID",
                // mineAmount: "挖币数量 (BHB)",
                // turnover: "成交金额"
            },

            recharge: {
                                symbol: 'العملة',
                address: 'عنوان الشحن',
                qrcode: 'رمز الاستجابة السريعة',
                msgtop: 'هذا العنوان للشحن فقط',
                msg1: 'يرجى عدم شحن أي أصول غير العملة إلى العنوان أعلاه، وإلا لن يتم استرداد الأصول.',
                msg2: 'بعد الشحن إلى العنوان أعلاه، يتطلب تأكيدًا من عقدة شبكة blockchain بأكملها، وعادةً ما يتم تأكيد 3 مرات على الشبكة الرئيسية للـ blockchain قبل الوصول.',
                msg3: 'الحد الأدنى لمبلغ الشحن:',
                msg3_1: "، لن يتم تسجيل الشحنات الأقل من الحد الأدنى.",
                msg4: 'عنوان الشحن الخاص بك لن يتغير بشكل متكرر، ويمكنك الشحن بشكل متكرر؛ إذا تم تغييره، سنحاول إعلامك من خلال إعلان الموقع أو البريد الإلكتروني.',
                msg5: 'يرجى التأكد من أمان الكمبيوتر والمتصفح لمنع التلاعب بالمعلومات أو تسريبها.',
                record: 'سجل الشحن',
                copysuccess: 'تم النسخ بنجاح!',
                time: 'وقت الوصول',
                amount: 'كمية الشحن',
                gettingaddress: "جارٍ الحصول على عنوان الشحن، يرجى الانتظار...",
                getaddress: "الحصول على عنوان الشحن",

                // memotips: "充值时请按要求输入此Memo，否则会丢失资产。",
                // withdrawrecharge: "提币码充值",
                // coderechargetip: "请输入提币码",
                // rechargesuccess: "恭喜！提币码充值成功！",
                // rechargeconfirm: "充值确认",
                // status: "状态"
                // copyerr: '复制失败！请手动复制',
                // qrcodeaddress: '充值地址二维码',
                // copy: '复制',
                // recharge: '充币',
            },
            withdraw: {
                                pickup: 'سحب العملة',
                symbol: 'العملة',
                address: 'عنوان السحب',
                num: 'كمية السحب',
                fee: 'الرسوم',
                arriamount: 'المبلغ المستلم',
                record: 'سجل السحب',
                symboltip: 'يرجى اختيار العملة',
                time: 'وقت السحب',
                status: 'الحالة',
                status_1: 'قيد المراجعة',
                status_2: 'قيد التحويل',
                status_3: 'فشل',
                status_4: 'نجاح',
                St5: 'سعر التصفية المقدر',
                St6: 'إجمالي الأصول = رصيد المحفظة + غير المحقق',
                St7: 'الأرباح والخسائر غير المحققة = جميع العقود المفتوحة باستخدام أحدث الأسعار',
                St8: 'رصيد المحفظة = الإيداع - السحب + الأرباح المحققة',
                St9: 'تم الرفض',
                add: 'إضافة',
                delete: 'حذف',
                txid: "TxId",
                wi1: 'الشبكة',
                wi2: 'المصادقة الأمنية',
                wi3: 'المبلغ المستلم',
                wi4: 'عنوان الاستلام',
                wi5: 'شبكة السحب',
                wi6: 'إجمالي المبلغ المسحوب',
                wi7: 'رسوم الشبكة',
                wi8: 'يرجى التأكد من إدخال عنوان السحب الصحيح وأن شبكة السحب التي اخترتها تتطابق مع العنوان',
                wi9: 'لا يمكن إلغاء طلب السحب بعد إنشائه',

                             wi10: 'متابعة',
                wi11: 'كلمة مرور الأموال',
                wi12: 'رمز التحقق عبر الهاتف',
                wi13: 'إرسال التحقق',
                wi14: 'رمز التحقق عبر البريد الإلكتروني',
                wi15: 'إرسال التحقق',
                wi16: 'إرسال',

                // addressmanager: '提币地址管理',
                // withdrawbycode: '提币码提币',
                // withdrawcode: '提币码',
                // avabalance: '可用余额',
                // msg1: '提币数量低于',
                // msg2: '时自动到账，否则需要人工审核',
                // increase: '提升额度',
                // tip1: '最多输入',
                // tip11: '位小数,最小值为',
                // tip2: '最大值为',
                // numtip1: '输入提币数量',
                // range: '范围',
                // msg3: '最小提币数量为',
                // msg4: '币',
                // msg5: '为保障资金安全，当您账户安全策略变更、密码修改、使用新地址提币，我们会对提币进行人工审核，请耐心等待工作人员电话或邮件联系',
                // msg6: '请务必确认电脑及浏览器安全，防止信息被篡改或泄露。',
                // addresstip: '请填入地址',
                // numtip2: '请填写正确提币数量，最小值为',
                // numtip3: '提币数量不得小于手续费',
                // amounttip: '请输入提币数量',
                // feetip1: '手续费最小值为',
                // feetip2: '最大值为',
                // remark: '备注',
                // addresslist: '地址列表',
                // safevalidate: '安全验证',
                // telno: '手机号码',
                // smscode: '手机验证码',
                // second: '秒',
                // clickget: '点击获取',
                // email: '邮箱',
                // emailcode: '邮箱验证码',
                // save: '保 存',
                // telerr: '手机号不正确',
                // emailerr: '邮箱不正确',
                // codeerr: '验证码不正确',
                // remarktip: '请输入备注',
                // savemsg1: '保存失败!',
                // savemsg2: '保存成功!',
                // operate: '操作',
                // fundpwdtip: '请输入资金密码',
                // click: '点击',
                // filtrate: '可筛选',
                // generateCode: "生成提币码",
                // withdrawcodelist: "提币码列表",
                // withdrawcodestatus: "状态",
                // submit: "提交",
                // generatecodesuccess: "提现码生成成功",
            }
        },
        member: {
            usercenter: "المركز الشخصي",
            account: "إدارة الحساب",
            assets: "إدارة الأموال",
            exchange: "إدارة التداول",
            curdelegate: "الوكالات الحالية",
            hisdelegate: "الوكالات السابقة",

            // securitycenter: '安全中心',
            // securitysetting: '安全设置',
            // accountsetting: '收款方式',
            // otc: "OTC管理"
        },
        regist: {

                       Res1: 'اسم المستخدم لا يمكن أن يكون فارغًا ويجب أن يتكون من أحرف كبيرة وصغيرة وأرقام، ويجب أن يحتوي على أحرف',
            username: 'اسم المستخدم',
            smscode: 'رمز التحقق',
            sendcode: 'إرسال رمز التحقق',
            pwd: 'كلمة مرور الدخول',
            repwd: 'تأكيد كلمة المرور',
            agreement: 'لقد قرأت ووافقت على',
            userprotocol: 'اتفاقية المستخدم',
            regist: 'تسجيل',
            teltip: 'يرجى إدخال رقم الهاتف',
            telerr: 'تنسيق رقم الهاتف غير صحيح، يرجى إعادة الإدخال',
            emailtip: 'يرجى إدخال البريد الإلكتروني',
            emailerr: 'تنسيق البريد الإلكتروني غير صحيح، يرجى إعادة الإدخال',
            confirmpwdtip: 'يرجى إدخال تأكيد كلمة المرور',
            confirmpwderr: 'كلمتا المرور غير متطابقتين!',
            pwdtip: 'يرجى إدخال كلمة مرور الدخول',
            pwdmsg: 'يجب أن تكون كلمة المرور مكونة من 6 أحرف على الأقل',
            telno: 'رقم الهاتف',
            email: 'عنوان البريد الإلكتروني',
            agreementtip: 'يرجى النقر للموافقة',
            promotion: 'رمز الدعوة',
            emailregist: 'التسجيل عبر البريد الإلكتروني',
            usernametip: 'يرجى إدخال اسم المستخدم',
            smscodetip: 'يرجى إدخال رمز التحقق عبر الرسائل القصيرة',

            // telregist: '手机注册',
            // hasaccount: '已有账号？请点击登录',
            // login: '登录',
            // country: '国家',
            // resendcode: '重新发送(',
            // confrimpwd: '确认密码',
            // usernamemsg: '用户名长度不能少于3位,多于15位',
            // countrytip: '请选择国家',
            // modaltitle: '请校验',
            // china: '中国',
            // singapore: '新加坡',
            // korea: '韩国',
            // japan: '日本',
            // thailand: '泰国',
            // russia: '俄罗斯',
            // uk: '英国',
            // vietnam: '越南',
            // india: '印度',
            // italy: '意大利',
            // hk: '香港',
            // malaysia: '马来西亚',
            // taiwan: '台湾省',
            // turkey: '土耳其',
            // germany: '德国',
            // france: '法国',
            // spain: '西班牙',
            // us: '美国',
        },
        safe: {
            beneficiaryTitle: 'معلومات المستفيد',
            beneficiaryEmpty: 'لم يتم تعيين معلومات المستفيد بعد',
            beneficiaryName: 'اسم المستفيد',
            beneficiaryIdNumber: 'رقم هوية المستفيد',
            beneficiaryMobilePhone: 'رقم هاتف المستفيد',
            beneficiaryNamePlaceholder: 'يرجى إدخال اسم المستفيد',
            beneficiaryIdPlaceholder: 'يرجى إدخال رقم هوية المستفيد',
            beneficiaryMobilePlaceholder: 'يرجى إدخال رقم هاتف المستفيد',
            beneficiaryTip: 'يُستخدم لتسجيل اسم المستفيد ورقم هويته ورقم هاتفه وتعديلها.',
            beneficiaryNameRequired: 'يرجى إدخال اسم المستفيد',
            beneficiaryNameInvalid: 'يجب أن يتكون اسم المستفيد من 2 إلى 30 حرفًا',
            beneficiaryIdRequired: 'يرجى إدخال رقم هوية المستفيد',
            beneficiaryIdInvalid: 'تنسيق رقم هوية المستفيد غير صحيح',
            beneficiaryMobileRequired: 'يرجى إدخال رقم هاتف المستفيد',
            beneficiaryMobileInvalid: 'تنسيق رقم هاتف المستفيد غير صحيح',
                     Ad1: 'يرجى تحميل بطاقة الضمان الاجتماعي أو رخصة القيادة أو جواز السفر',
            Ad2: 'يرجى تحميل أحد هذه الملفات قبل الإرسال',
            Ad3: 'الاسم الكامل',
            Ad4: 'عنوان الاتصال',
            Ad5: 'البث المباشر',
            Ad6: 'بثي المباشر',
            Ad7: 'فشل الإضافة، يمكن إضافة 3 كحد أقصى',
            safelevel_low: 'مستوى الأمان: منخفض',
            safelevel_high: 'مستوى الأمان: مرتفع',
            safelevel_medium: 'مستوى الأمان: متوسط',
            bind: 'ربط',
            binded: 'تم الربط',
            binding: 'قيد المراجعة',
            bindretry: 'إعادة المحاولة',
            verifypass: "تم التحقق",
            verified: 'التوثيق بالهوية الحقيقية',
            notverified: "غير موثق",
            verifiedtip: 'لضمان أمان حسابك، يرجى إكمال التوثيق بالهوية الحقيقية قبل إجراء أي عمليات تداول!',

            save: 'حفظ',
            reset: 'إعادة تعيين',
            email: 'البريد الإلكتروني',
            bindemail: 'ربط البريد الإلكتروني',
            loginpwd: 'كلمة مرور الدخول',
            emailcode: 'رمز التحقق عبر البريد الإلكتروني',
            clickget: 'انقر للحصول',
            second: 'ثانية',
            phone: 'الهاتف',
            bindphone: 'ربط الهاتف',
            phonecode: 'رمز التحقق عبر الهاتف',
            logintip: 'يستخدم عند تسجيل الدخول إلى المنصة',
            edit: 'تعديل',
            oldpwd: 'كلمة المرور القديمة',

                       newpwd: 'كلمة المرور الجديدة',
            confirmnewpwd: 'تأكيد كلمة المرور الجديدة',
            fundpwd: 'كلمة مرور الأموال',
            fundtip: 'عند تغيير أموال الحساب، يلزم التحقق من كلمة مرور الأموال أولاً',
            set: 'إعداد',
            confirmpwd: 'تأكيد كلمة المرور',
            oldfundpwd: 'كلمة مرور الأموال القديمة',
            newfundpwd: 'كلمة مرور الأموال الجديدة',
            newpwdmsg1: 'يرجى إدخال كلمة مرور جديدة لا تقل عن 6 أحرف',
            newpwdmsg2: 'كلمة المرور الجديدة غير متطابقة',
            pwdmsg1: 'يرجى إدخال كلمة مرور لا تقل عن 6 أحرف',
            pwdmsg2: 'كلمة المرور غير متطابقة',
            emailtip: 'يرجى إدخال عنوان البريد الإلكتروني',
            codetip: 'يرجى إدخال رمز التحقق',
            realnametip: 'يرجى إدخال الاسم الحقيقي',
            idcardtip: 'يرجى إدخال رقم الهوية',
            upload_negativetip: 'يرجى تحميل صورة ظهر الهوية',
            upload_handtip: 'يرجى تحميل صورة الهوية مع صورة شخصية',
            save_success: 'تم الحفظ بنجاح!',
            save_failure: 'فشل الحفظ!',
            idcard_verifymsg1: "1- يدعم تنسيقات JPG و PNG، حجم الملف أقل من 8M؛ يجب أن تكون المعلومات على الوثيقة واضحة ومرئية، ولا يسمح بأي تعديل أو حجب، ويجب أن يكون رقم الوثيقة والاسم واضحين.",
            idcard_verifymsg2: "2- يجب أن تكون الصورة بدون غطاء للرأس، يُفضل بدون مكياج، مع وضوح ملامح حامل الوثيقة وإظهار الذراع بالكامل.",
            idcard_verifymsg3: "3- يجب أن تكون الصورة ممسكًا بالوثيقة مع نص مكتوب بخط اليد (الاسم + تاريخ التقديم) 'جميع أفعالي على هذا الموقع هي من قبلي شخصيًا، وقد أدركت المخاطر المرتبطة بها، وأنا على استعداد لتحمل جميع العواقب القانونية لهذا الحساب.'"

            // telnotip: '请输入手机号',
            // oldpwdtip: '请输入原密码',
            // bindphonetip: '请先绑定手机!',
            // resetfundpwd: '重置资金密码',
            // upload_positivetip: '请上传身份证正面照',
            // binderr: '失败',
            // realname: '真实姓名',
            // nickname: '昵称',
            // size: '上传图片大小不能超过5M',
            // idcard: '身份证号',
            // upload: '点击上传',
            // upload_positive: '身份证正面照',
            // upload_negative: '身份证反面照',
            // upload_hand: '手持身份证与个人签名照',
        },
        otcorder: {
            money: 'المبلغ',
        },
        extension: {
            currrecharge: 'المعاملة الحالية',
        },
        promotion: {
            exchange: "التبادل الفوري",

        },
        // mining: {
        //     title: "我的矿机列表",
        //     empty: "暂无矿机",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本矿机产能可通过邀请好友获得提升，每邀请一人兑换矿机，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "产出币种",
        //     miningPeriod: "产出周期",
        //     miningDays: "挖矿时间",
        //     miningedDays: "已挖时间",
        //     miningDaysProfit: "基础产能",
        //     miningCurrentDaysProfit: "实际产能",
        //     status0: "待部署",
        //     status1: "已部署",
        //     status2: "已结束"
        // },
        // locked: {
        //     title: "我的锁仓列表",
        //     empty: "暂无锁仓",
        //     day: "天",
        //     week: "周",
        //     month: "月",
        //     year: "年",
        //     invitetip1: "本锁仓产能可通过邀请好友获得提升，每邀请一人参与锁仓，产能提升",
        //     invitetip2: "%，产能提升上限",
        //     miningUnit: "释放币种",
        //     miningPeriod: "释放周期",
        //     miningDays: "总释放周期",
        //     miningedDays: "已释放周期",
        //     miningDaysProfit: "基础释放",
        //     miningCurrentDaysProfit: "实际释放",
        //     status0: "待释放",
        //     status1: "释放中",
        //     status2: "已结束",
        //     totallocked: "总锁仓"
        // },
    },
    cms: {
        noticecenter: 'مركز الإعلانات',
        notice: 'إعلان',
        servicecenter: 'مركز خدمة العملاء',
        aboutus: 'من نحن',
        features: "ميزات المنصة",
        contactus: "اتصل بنا",
        nextnotice: 'المقالة التالية',
        prevnotice: "المقالة السابقة",
        notexist: "الإعلان الذي تزوره غير موجود أو تم حذفه!",
        otherhelp: "المقالات ضمن هذه المجموعة",
        scanforshare: "مسح للمشاركة",
        download: "تحميل فوري",
        downloadslogan: "-منصة تداول الأصول الرقمية العالمية"
        // newshelp: '新手帮助',
        // appdownload: 'APP下载',
        // onlineservice: '在线客服',
        // faq: '常见问题',
        // exchangerule: '交易规则',
        // about: '关于',
        // joinus: '加入我们',
        // useprotocol: '使用协议',
        // feenote: '资费说明',
        // merchantprocotol: '商家协议',
        // noticelist: '公告列表',
    },
    description: {
                title1: 'الأمان على مستوى المؤسسات المالية',
        title2: 'الإيداع والسحب السريع',
        title3: 'خدمة عالمية',
        title4: 'اختيار صارم للأصول',
        message1: 'نظام شامل لإدارة المخاطر المالية ومكافحة السرقة، مع محافظ ساخنة وباردة ونظام توقيع متعدد لضمان أمان الأموال',
        message2: 'الإيداع والسحب في أسرع وقت ممكن خلال 3 دقائق، مع مراجعة يدوية على مدار 24 ساعة لحماية العملاء من تفويت أفضل فرص الاستثمار',
        message3: 'شبكة خدمات الأعمال العالمية تغطي جميع أنحاء العالم، مما يساعدك على الاستثمار في الأصول المشفرة العالمية والتداول مع المستخدمين من جميع أنحاء العالم',
        message4: 'اختيار صارم لمشاريع التشفير عالية الجودة، مما يوفر لك تصفية 80% من المشاريع عالية المخاطر',
        aboutdesc1: "هي منصة رائدة عالميًا في تداول الأصول الرقمية، مسجلة في جزر كايمان، مع فريق تشغيل رئيسي مقره في هونغ كونغ. يأتي الأعضاء الرئيسيون من شركات الإنترنت والتمويل الرائدة، ومعظمهم من المؤمنين بعمق بالبيتكوين وتكنولوجيا البلوكشين. نحن مقتنعون بأن البلوكشين سيغير النظام المالي الاحتكاري التقليدي وسيؤسس هيكلًا اجتماعيًا أكثر ديمقراطية واستقلالية.",
        aboutdesc2: "تمتلك المنصة بنية تجارية على مستوى المؤسسات المالية، مع محرك تداول عالي الأداء تم تطويره داخليًا، ونظام محفظة إيداع بارد بالكامل مع توقيع متعدد ونظام حماية عالي ضد هجمات DDOS، مما يضمن أمان أصول العملاء.",
        aboutdesc3: "لتمكين العملاء من الاستفادة القصوى من فرص الاستثمار، يعتمد قسم خدمة العملاء على إدارة مسطحة وتم إنشاء آلية استجابة سريعة للخدمة، مع مديري أصول يعملون على مدار 24 ساعة طوال العام لتوفير خدمات الإيداع والسحب، مما يضمن إكمال العملاء لعملية الإيداع والسحب في غضون 25 دقيقة.",
        aboutdesc4: "يتم اختيار المشاريع عالية الجودة بعناية وتوفير خدمات إدارة أصول آمنة ومستقرة. مع التزامنا بمبادئ \"الصدق، العدالة، الحماس، الانفتاح\"، نسعى جاهدين لتوفير منصة تداول آمنة وموثوقة وفعالة وودية.",
        aboutdesc5: "على الرغم من أن الأصول الرقمية لا تزال في دائرة صغيرة، إلا أننا نؤمن بأن هذه الأصول التي يمكن للجميع التحكم فيها بالكامل ستنتشر في المستقبل، فلنعمل معًا ونتطلع إلى ذلك!",
        support: "الدعم الفني",
        report: "الشكاوى والاقتراحات",
        service: "خدمة العملاء",
        apply: "طلب إدراج العملة",
        coop: "التعاون التجاري",
        community: "المجتمع",
        wechat: "WeChat",
        addwechat: "أضف \"bmate601\" كصديق على WeChat للانضمام إلى مجتمع WeChat للمكافآت",
        weibo: "Weibo",
        twitter: "Twitter",
        biyong: "Biyong",
        telegram: "Telegram",
        medium: "Medium",
        reddit: "Reddit"

          // scanqrcode: "扫描二维码，下载APP",
    },
    footer: {
               notice: 'إعلانات المنصة',
        gsmc: 'منصة تداول الأصول الرقمية العالمية عالية الجودة',
        gsjj: 'حول',
        gywm: 'من نحن',
        jrwm: 'انضم إلينا',
        lxwm: 'اتصل بنا',
        bzzx: 'مركز المساعدة',
        fwtk: 'اتفاقية المستخدم',
        fltk: 'شرح الرسوم',
        xszn: "دليل المبتدئين",
        cjwt: "الأسئلة الشائعة",
        mztk: "بنود الإعفاء من المسؤولية",
        ystk: "بنود الخصوصية",
        tkxy: "اتفاقية الشروط",
        gybzb: "حول BZB",
        kfyx: "بريد خدمة العملاء",
        swhz: "التعاون التجاري",
        sbsq: "طلب إدراج العملة",
        jyzn: "دليل التداول",
        bzzl: "معلومات العملة",
        tsjb: "تقديم شكوى",
        apidoc: "واجهة برمجة التطبيقات (API)",
        zwkf: "غير متاح حاليًا"

        // wechatkefu: "微信客服",
        // wechat: "微信客服",
        // yqlj: '友情链接',
        // bah: '沪ICP备13026899号-3',
        // changjian: '常见问题',
        // shiyong: '使用协议',
        // feilv: '费率说明',
        // lianxi: '联系邮箱',
        // biyong: '币用',
        // xsrm: '新手教程',
        // czzn: '充值指南',
        // ptsm: '平台说明',
        // fysm: '交易规则',
    },
    index: {
         max: 'الأعلى',
         download_code: 'امسح رمز QR لتنزيل التطبيق واستقبال هدية الترحيب'
    },
    home: {
        login: {
            title: 'ابدأ تداول العملات الرقمية',
            desc: 'يدعم أكثر من 500 عملة وأدوات تداول متعددة',
            btnText: 'اذهب للتداول'
        },
        unlogin: {
            title: 'ابدأ رحلتك في العملات الرقمية',
            desc: 'سجل واحصل على هدية ترحيبية كبيرة',
            placinfo: 'الهاتف/البريد الإلكتروني',
            btnText: 'تسجيل'
        },
        WelfareCenter: 'مركز المكافآت',
        Welcome_ceremony: 'هدية الترحيب',
        Airdrop: 'التوزيع المجاني',
        DailyGain: 'ربح يومي',
        AirdropGift: 'هدية التوزيع المجاني',
        financial_management: 'إدارة مالية متميزة·',
        Zhoude: 'ربح أسبوعي',
        height_is: 'يصل إلى',
        Happiness: 'مهرجان الخمسة بركات·',
        Monthly: 'ربح شهري',
        CarveUp: 'تقسيم',
        download: {
            transactions_anytime: 'التداول في أي وقت وأي مكان',
            scan_code: 'امسح الرمز للتنزيل',
            download_more: 'تنزيل المزيد'
        },
        brand: {
            digital_platform: 'منصة رائدة لتداول الأصول الرقمية',
            rich_digital: 'خدمات تداول وإدارة الأصول الرقمية المتنوعة لتلبية احتياجات التداول المختلفة',
            High_quality_digital: 'أصول رقمية عالية الجودة',
            Turnover: 'حجم التداول',
            safety_risk: 'نظام إدارة مخاطر أمنية عالمي المستوى',
            multi_factor: 'تخزين غير متصل بالإنترنت، طرق تشفير متعددة العوامل، مراقبة المنصة على مدار 24 ساعة طوال العام، حماية شاملة لأصول المستخدمين',
            Security_reserve: 'احتياطي الأمان',
            accident: '9 سنوات بدون حوادث',
            safetyrisk: 'إدارة مخاطر أمنية عالية المستوى',
            choice_trusted: 'اختيار ملايين المستخدمين الموثوق به',
            transaction_service: 'مراكز خدمات تداول محلية في العديد من الدول والمناطق، لإنشاء نظام بيئي للبلوكشين متعدد الخدمات',
            ten_thousand: 'عشرة آلاف',
            User_preference: 'الاختيار الأول للمستخدمين',
            Countries_covered: 'الدول المغطاة'
        },
        trading: {
            digital_currency: 'ابدأ رحلتك في العملات الرقمية',
            register: 'تسجيل',
            login: 'تسجيل الدخول',
            currency_transaction: 'ابدأ تداول العملات الرقمية',
            to_trade: 'اذهب للتداول'
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/lang/ar/index.js